module.exports = __webpack_public_path__ + "img/serve4.011f2783.png";